import { getLandlordReviewPath } from '../../../../../../constants/urls';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { getPropertyId } from '../../../../../../utils/route';
import GenericBackLink from '../../../../../../components/BackLink';

export default function BackLink() {
  const location = useLocation();
  const match = useRouteMatch();
  const origin = getLandlordReviewPath(getPropertyId(location), match.params.applicationId);
  return (
    <GenericBackLink to={origin} id="back-to-application-overview">
      Application overview
    </GenericBackLink>
  );
}
